import { BaseQuestionnaireRoute } from '../slice';

export type WhereILiveSubRoutes = {
  current_address: BaseQuestionnaireRoute;
  history: BaseQuestionnaireRoute;
  housing_arrangements: BaseQuestionnaireRoute;
  // immigration: BaseQuestionnaireRoute;
};

export type WhereILiveRoutes = BaseQuestionnaireRoute & WhereILiveSubRoutes;

export const whereILiveRoutes: { where_i_live: WhereILiveRoutes } = {
  where_i_live: {
    title: 'Where I Live',
    path: 'where_i_live',
    isValid: undefined,
    toggle: false,
    current_address: {
      title: 'Current Address',
      path: 'current_address',
      isValid: undefined,
    },
    history: {
      title: 'History',
      path: 'history',
      isValid: undefined,
    },
    housing_arrangements: {
      title: 'Housing Arrangements',
      path: 'housing_arrangements',
      isValid: undefined,
    },
    // immigration: {
    //   title: 'Immigration',
    //   path: 'immigration',
    //   isValid: undefined,
    // },
  },
};
